import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectAll = createSelector(
  [(state: ApplicationState) => state.CustomFieldStore.data],
  (data) => data
)
